import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  width: 100%;
  background:
    linear-gradient(
      90deg,
      #e4afcb 0%,
      #b8cbb8 0%,
      #b8cbb8 0%,
      #e2c58b 30%,
      #c2ce9c 64%,
      #7edbdc 100%
    ),
    linear-gradient(0deg, rgba(51, 51, 51, 0.1), rgba(51, 51, 51, 0.1));
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  padding: ${() => `${viewSizeCalculator(0.75)}`};
  // padding: ${(props) => (props.isScrolled ? "8px 16px" : "16px 24px")};

  max-height: ${viewSizeCalculator(5)};

  transition: all 0.3s ease-in-out;
`;

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  position: relative;
  svg {
    width: ${() => `${viewSizeCalculator(3)}`};
    height: ${() => `${viewSizeCalculator(3)}`};
  }
`;

export const LoadingContainer = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`};
  height: ${() => `${viewSizeCalculator(3)}`};
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: #333;
  // opacity: 30%;
  background-color: #3333334D;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
`;

export const RightIconWrapper = styled.div`
  display: flex;
  // align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
`;

export const HospitalTitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(1.5)}`}; // 2.5rem

  font-weight: 700;
  font-family: Inter;

  margin-top: ${() => `${viewSizeCalculator(0.5)}`};
  line-height: ${() => `${viewSizeCalculator(3.026)}`}; // 3.026rem
  color: #ffffff;
  padding: ${() => `${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)}`};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: ${() => `${viewSizeCalculator(60)}`};

  transform: translate(${viewSizeCalculator(4)}, ${viewSizeCalculator(-4)});

  /* transition: all 0.3s ease-in-out; */
`;

export const HospitalSubTitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.813)}`}; // 1rem

  opacity: 80%;
  font-weight: 600;
  font-family: Inter;
  margin-top: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
  line-height: ${() => `${viewSizeCalculator(1.21)}`}; // 1.21rem
  color: #ffffff;
  padding: ${() => `${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)}`};
  margin-bottom: ${() => `${viewSizeCalculator(1.5)}`};
  text-transform: capitalize;
  transform: translate(${viewSizeCalculator(4)}, ${viewSizeCalculator(-5)});
  transition: all 0.3s ease-in-out;
`;
